var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0153 31.5005C24.3715 31.5005 26.5313 30.6397 28.1928 29.2199L24.4168 25.459C23.7372 25.9273 22.9064 26.2142 22.0153 26.2142C19.6743 26.2142 17.7863 24.3262 17.7863 21.9852C17.7863 19.9008 19.2816 18.179 21.2602 17.8317V12.5C16.3514 12.8927 12.5 16.9857 12.5 21.9852C12.5 27.2413 16.7592 31.5005 22.0153 31.5005Z",
    fill: "#7a7a7a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4893 24.3879L29.2501 28.1488C30.5188 26.6686 31.3344 24.7957 31.4854 22.7266H26.1689C26.0632 23.3458 25.8215 23.9046 25.4893 24.3879Z",
    fill: "#7a7a7a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7703 12.5V17.8165C24.5072 18.1337 25.8665 19.493 26.1837 21.2299H31.5002C31.1377 16.5781 27.4221 12.8625 22.7703 12.5Z",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDetailsIcon);
export default __webpack_public_path__ + "static/media/reportDetailsIcon.e85b170c.svg";
export { ForwardRef as ReactComponent };